export default {
  GET_VARIABLES_APP: `#graphql
  query getVariablesApp {
    getVariablesApp
    {
      brands,
      colors,
      conveyors,
      methods,
      sizes,
      designs,
      articles {
        article,
        letter
      },
      tiers,
      users {
        name,
        dni
      },
      permissionsString,
      balance,
      data {
        sahet {
          name,
          documentNumber,
          address,
          phone
        },
        bassica {
          name,
          documentNumber,
          address,
          phone
        },
      },
      packages
    }            
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/app.js